<template>
    <div class="msgbl-text-row" :class="{'has-padding': hasPadding}"><slot/></div>
</template>
<script>
export default {
  name: 'MsgblTextRow',
  props: {
    hasPadding: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';

.msgbl-text-row {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.64;
  letter-spacing: 0.1px;
  display: flex;

  &.has-padding {
    padding-left: 10px;
    padding-right: 10px;
  }

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  &:empty {
    display: none;
  }
}
</style>
